import { WordfillContentSource } from "seneca-common/features/module/module-types/wordfill/types";

export const canBeTested = (contentSource: WordfillContentSource): boolean => {
  const { words } = contentSource;

  // No text present
  if (words.length === 0) {
    return false;
  }

  // Text contains no testable words
  return !(
    contentSource.words.length === 1 &&
    typeof contentSource.words[0] === "string"
  );
};
